<!-- All component used in this one, have to be declared in Sharted Module -->
<scf-v2-main-s1 [scfMaster]="originalBody" [disabled]="true" [status]="status">
</scf-v2-main-s1>
<scf-v2-main-s2
  [scfMaster]="originalBody"
  [disabled]="true"
  [status]="status"
></scf-v2-main-s2>
<!-- <form-history-signatures
  [update]="update"
  *ngIf="update"
></form-history-signatures> -->
<scf-v2-main-s4-holdpoints
  [scfMaster]="originalBody"
  [disabled]="true"
  [status]="status"
  [amendmentID]="update?.amendmentId ?? 0"
  [isLogView]="true"
>
</scf-v2-main-s4-holdpoints>
